const loader = {
    killReact: window.loader.killReact,
    killReactChangePage: window.loader.killReactChangePage,
};

export default loader;
